import script from "./setUpPartnershipSecond.vue?vue&type=script&setup=true&lang=js"
export * from "./setUpPartnershipSecond.vue?vue&type=script&setup=true&lang=js"

import "./setUpPartnershipSecond.vue?vue&type=style&index=0&id=026a8b7e&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-026a8b7e"]])

export default __exports__